import isFalsy from '../helpers/is-falsy';
import isTruthy from '../helpers/is-truthy';

const projectRoles = {
  'Import ID': {
    requirementType: 'required',
    description:
      'This ID can be a text value (or numeric), but needs to be unique for each record that is imported. This value is leveraged for identifying each imported record in the event that errors are found and also designates the records as an “imported” record, as opposed to a record entered via the Ruddr application.',
    dataType: 'string',
    validator: (value) => value.trim() !== '',
  },

  'Client Name': {
    requirementType: 'required',
    description:
      'The name of the client associated with the role. This field must match the Name of a Client exactly, including spaces, punctuation and capitalization, otherwise the row may be skipped during import.',
    dataType: 'string',
    validator: (value) => value.trim() !== '',
  },
  'Project Name': {
    requirementType: 'required',
    description:
      'The name of the project associated with the role. This field must match the name of a project exactly, including spaces, punctuation and capitalization, otherwise the row may be skipped during import.',
    dataType: 'string',
    validator: (value) => value.trim() !== '',
  },
  'Role Name': {
    requirementType: 'required',
    description: 'Name of the role, which should be unique per project.',
    dataType: 'string',
    validator: () => true,
  },
  Billable: {
    requirementType: 'optional',
    description: '"No" if you consider this role as not billable to the project.',
    dataType: 'boolean',
    validator: (value) => {
      return !value || isTruthy(value) || isFalsy(value);
    },
  },
  Rate: {
    requirementType: 'optional',
    description: 'The billable rate of the role. This value will be ignored if non-billable.',
    dataType: 'number',
    validator: (value) => {
      return !value || (!isNaN(parseFloat(value)) && isFinite(value) && Number(value) >= 0);
    },
  },

  Enabled: {
    requirementType: 'optional',
    description: '"No" if you consider this role inactive and disabled on the project.',
    dataType: 'boolean',
    validator: (value) => {
      return !value || (value && (isTruthy(value) || isFalsy(value)));
    },
  },
  Practice: {
    requirementType: 'optional',
    description:
      'The name of the practice associated with the role, the name  must match exactly, including spaces, punctuation and capitalization.',
    dataType: 'string',
    validator: () => true,
  },
  'Business Unit': {
    requirementType: 'optional',
    description:
      'The name of the business unit associated with the role. The name must match exactly, including spaces, punctuation and capitalization.',
    dataType: 'string',
    validator: () => true,
  },
  Location: {
    requirementType: 'optional',
    description:
      'The name of the location associated with the role. The name must match exactly, including spaces, punctuation and capitalization.',
    dataType: 'string',
    validator: () => true,
  },
  Discipline: {
    requirementType: 'optional',
    description:
      'The name of the discipline associated with the role. The name must match exactly, including spaces, punctuation and capitalization.',
    dataType: 'string',
    validator: () => true,
  },
  'Estimated Billable Hours': {
    requirementType: 'optional',
    description: 'The estimated number of billable hours that is used in a detailed budget.',
    dataType: 'number',
    validator: (value) => {
      return !value || (!isNaN(parseFloat(value)) && isFinite(value) && Number(value) >= 0);
    },
  },
  'Estimated Non-billable Hours': {
    requirementType: 'optional',
    description: 'The estimated number of non-billable hours that is used in a detailed budget.',
    dataType: 'number',
    validator: (value) => {
      return !value || (!isNaN(parseFloat(value)) && isFinite(value) && Number(value) >= 0);
    },
  },
  'Estimated Monthly Billable Hours': {
    requirementType: 'optional',
    description:
      'Only used when the project is monthly recurring billing type. The estimated number of billable hours that is used in a detailed budget.',
    dataType: 'number',
    validator: (value) => {
      return !value || (!isNaN(parseFloat(value)) && isFinite(value) && Number(value) >= 0);
    },
  },
  'Estimated Monthly Non-billable Hours': {
    requirementType: 'optional',
    description:
      'Only used when the project is monthly recurring billing type. The estimated number of non-billable hours that is used in a detailed budget.',
    dataType: 'number',
    validator: (value) => {
      return !value || (!isNaN(parseFloat(value)) && isFinite(value) && Number(value) >= 0);
    },
  },
};

export default projectRoles;
